import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Badge, Button } from './ui';
type HeroProps = {
  onPurchaseRequest?: () => void;
};
export function Hero({
  onPurchaseRequest
}: HeroProps) {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('planes');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
      return;
    }
    onPurchaseRequest?.();
  };
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-14" data-mp="1274nzp1vrg78">
      {/* Background glow */}
      <div className="hero-backdrop absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-15" data-mp="sartioyigybf"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-16" data-mp="3d1a8vl7kyddt">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-17" data-mp="3czfk1vt6u14g">
          <Sparkles className="w-6 h-6 text-brand-400" aria-hidden="true" data-id="element-18" data-mp="381e0zavri1sz" />
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-19" data-mp="3j7zgtn69y0is">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-[52px] font-black text-white mb-4 tracking-tight text-[23px]" data-id="element-20" data-mp="3o5j39ad4ljlt">
          ¿ANSIEDAD? ¿INSOMNIO? ¿SENTÍS QUE EL DINERO NO FLUYE COMO DEBERÍA?
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-21" data-mp="3e7l59v5gs8g0">
          <div className="hero-mockup-glow absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-22" data-mp="30hre366hlc34"></div>
          <img src="https://cdn.magicpatterns.com/uploads/kWETvKAHd6UZ4RgRyj5txY/MOCKUP_TRANSPARANTE.png" alt="Punto Digital Megapack Reiki, con seis protocolos y cinco bonos incluidos" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" data-mp="35aat87ktofa1" />
        </div>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-24" data-mp="s2bckbltt7bh">
          Elegí el protocolo que hoy más necesitás y empezá un proceso guiado de 21 días para recuperar la calma, dormir mejor y desbloquear tu energía para avanzar con mayor equilibrio y abundancia.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-25" data-mp="de6o0r03e1ks">
          <Badge className="whitespace-nowrap" data-id="element-26" data-mp="1b1fez1iv42u6">✅ 100% Digital</Badge>
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="1ayjhfeaxfg69">⚡ Acceso inmediato</Badge>
          <Badge className="whitespace-nowrap" data-id="element-28" data-mp="162m0p6vr47sy">✨ 6 Protocolos + 5 Bonos</Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-29" data-mp="11152jj4nizg2">
          <Button size="md" className="w-full md:w-auto group" onClick={scrollToPurchase} data-id="element-30" data-mp="x1nvil9ktu8s">
            <span className="group-hover:scale-110 transition-transform" data-id="element-31" data-mp="3lui9cqv5izld">
              QUIERO EMPEZAR MI PROTOCOLO
            </span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-32" data-mp="1x9b4gyotkxbi" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-33" data-mp="21aej5hv4snb5">
            <span className="flex items-center" data-id="element-34" data-mp="269he29hedd5e">🛡️ Garantía 7 días</span>
            <span className="flex items-center" data-id="element-35" data-mp="26868q58azxc6">🔒 Pago seguro</span>
            <span className="flex items-center" data-id="element-36" data-mp="2b2agurtb2beu">⚡ Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}